<template>
    <NuxtLink
        :to="{ path: '/Feeds/Blog-Inhalte/' + slug }"
    >
        <article>
            <div class="blog-header">
                <HexagonImage :img-src="strapiImageUrl as string"/>
            </div>
            <div class="blog-content">
                <p v-if="Datum">
                    {{
                        new Date(Datum).toLocaleDateString('de-DE', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        })
                    }}
                </p>
                <p v-else-if="publishedAt">
                    {{
                        new Date(publishedAt).toLocaleDateString('de-DE', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        })
                    }}
                </p>
              <h2 class="h3 truncate">
                    {{ title }}
              </h2>
            </div>
            <div class="blog-footer">
              <UButton leading-icon="i-lucide-arrow-right">
                Beitrag lesen
              </UButton>
            </div>
        </article>
    </NuxtLink>
</template>

<script setup lang="ts">
import type {BlogPost} from '~~/types/strapi-blog';

const props = defineProps<Partial<BlogPost>>();

const strapiImageUrl = computed(() => (props.previewImage?.url ? useStrapiMedia(props.previewImage.url) : null));
</script>

<style scoped>

</style>
